<div class="card bg-dark-lighter text-white">
  <div class="card-header ">
    {{ "Suspended User List" | uppercase }}
    <fx-export-button
      classes="pull-right text-red"
      icon="fa fa-print"
      text="Export"
      [tableId]="'tblSuspendedUser'"
      fileName="suspended_user_list"
    ></fx-export-button>
  </div>
  <div class="card-body">
    <div class="row mb-3">
      <div class="col-12 col-md-6 mb-2">
        <div class="input-group search-group" [ngClass]="{ loading: loading }">
          <input
            type="text"
            class="form-control bg-dark"
            name="keyword"
            placeholder="ID, email"
            [(ngModel)]="searchKey"
           />
          <button
            class="btn btn-main"
            (click)="search()"
            type="button">
            Search
          </button>
          <button
            class="btn btn-main"
            (click)="refresh()"
            type="button">
            Refresh
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="table-responsive">
          <table class="rox-table table-bordered bg-dark" id="tblSuspendedUser">
            <thead>
              <tr>
                <th class="text-center font-bold">ID</th>
                <th class="text-center font-bold">Account number</th>
                <th class="text-center font-bold">Email</th>
                <th class="text-center font-bold">Status</th>
                <th class="text-center font-bold"></th>
            </thead>
            <tbody>
              <tr  
              *ngFor="
                let item of suspendedUsers
                  | paginate
                    : {
                        id: 'suspendedUsers',
                        itemsPerPage: pageInfo.pageSize,
                        currentPage: pageInfo.pageIndex,
                        totalItems: pageInfo.totalRecord
                      };
                let i = index
              ">
                <td>{{item.id}}</td>
                <td>{{item.login}}</td>
                <td>{{item.Email}}</td>
                <td>
                  <span class="text-red" >
                    Suspended
                  </span>
                </td>
                <td > 
                  <span 
                    class="text-primary unsuspend" 
                    (click)="unSuspend(item.login)">
                    Unsuspend
                  </span>  
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row mt-15">
          <div class="col">
            <div class="pagination-wrapper">
              <pagination-controls
                id="suspendedUsers"
                (pageChange)="pageChanged($event)"
                responsive="true"
                previousLabel="Prev"
                nextLabel="Next">
              </pagination-controls>
            </div>
          </div>
          <div class="col-auto">
            <span class="data-info">
              Found: {{ pageInfo.totalRecord }} {{ pageInfo.totalRecord > 1 ? "records" : "record" }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

